import { useState } from "react";
import './App.css';
import Card from './components/card/Card';
import Header from './components/header/Header';
import { languages } from "./helpers/data"; // Veriyi burada import ediyoruz

function App() {
  const [search, setSearch] = useState("");

  // Filtreleme mantığı
  const filteredLanguages = languages.filter((lang) =>
    lang.name.toLowerCase().includes(search.toLowerCase().trim())
  );

  return (
    <div className="main-container">
      <Header />
      
      {/* Arama Kutusu turuncu kutunun dışında daha şık durur */}
      <div className="search-input-wrapper">
        <input
          type="search"
          placeholder="Search Language..."
          className="search-bar"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>

      {/* Filtrelenmiş veriyi Card'a prop olarak gönderiyoruz */}
      <Card languages={filteredLanguages} />
    </div>
  );
}

export default App;